import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { LinkSimple, LinkBreak, Copy } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";

const mmss = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

// Tautan ID privasi WhatsApp (@lid) <-> Nomor Penguji, via kode sekali pakai.
export const ClinaraLidLinks = ({ testers }) => {
  const [data, setData] = useState({ items: [], server_ts: 0 });
  const [skew, setSkew] = useState(0);
  const [, tick] = useState(0);
  const load = useCallback(() => api.get("/admin/clinara/lid-links").then((r) => {
    setData(r.data); setSkew(r.data.server_ts - Date.now() / 1000);
  }).catch((e) => toast.error(apiError(e))), []);
  useEffect(() => { load(); const id = setInterval(load, 10000); return () => clearInterval(id); }, [load, testers]);
  useEffect(() => { const id = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(id); }, []);
  const makeCode = async (phone) => {
    try { await api.post("/admin/clinara/lid-link-code", { phone }); toast.success("Kode tautan dibuat (berlaku 10 menit)"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const unlink = async (phone) => {
    if (!window.confirm("Lepas tautan ID privasi untuk nomor ini?")) return;
    try { await api.delete(`/admin/clinara/lid-links/${phone}`); toast.success("Tautan dilepas"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const now = Date.now() / 1000 + skew;
  return (
    <div data-testid="clinara-lid-links" className="mt-4 rounded-2xl border border-rose-100/70 bg-white p-5">
      <h2 className="mb-1 flex items-center gap-1.5 text-sm font-bold text-slate-600"><LinkSimple size={16} /> Tautan ID Privasi WhatsApp (@lid) — Nomor Penguji</h2>
      <p className="mb-3 text-xs text-slate-400">WhatsApp kini menyembunyikan nomor pengirim (ID @lid) dan gateway belum bisa memetakannya. Buat kode, lalu kirim kode itu sebagai pesan WhatsApp dari nomor penguji ke nomor klinik. Kode sekali pakai, berlaku 10 menit, tidak dibalas bot, dan isinya tidak disimpan.</p>
      {data.items.length === 0 ? <p className="text-sm text-slate-400">Belum ada Nomor Penguji.</p> : (
        <ul className="space-y-2">
          {data.items.map((it) => {
            const left = it.code ? Math.max(0, Math.round(it.code_expires_ts - now)) : 0;
            return (
              <li key={it.phone} data-testid={`lid-link-${it.phone}`} className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-slate-50 px-3 py-2">
                <div className="min-w-0">
                  <p className="font-mono text-sm font-bold text-slate-700">{it.phone}</p>
                  <p data-testid={`lid-link-status-${it.phone}`} className={`text-[11px] font-semibold ${it.linked ? "text-emerald-700" : "text-slate-400"}`}>
                    {it.linked ? `Tertaut · ID ${it.lid_masked} · ${String(it.linked_at || "").slice(0, 16).replace("T", " ")}` : "Belum tertaut"}
                  </p>
                  {it.code && left > 0 && (
                    <p data-testid={`lid-link-code-${it.phone}`} className="mt-1 flex items-center gap-1.5 text-xs text-[#6A38C7]">
                      Kirim dari nomor ini: <span className="rounded bg-[#EEE6FF] px-2 py-0.5 font-mono text-sm font-extrabold tracking-wider">{it.code}</span>
                      <button onClick={() => { navigator.clipboard?.writeText(it.code); toast.success("Kode disalin"); }} aria-label="Salin kode" className="text-slate-500"><Copy size={14} /></button>
                      <span className="text-slate-400">· {mmss(left)}</span>
                    </p>
                  )}
                </div>
                <div className="flex gap-1.5">
                  <button data-testid={`lid-link-make-${it.phone}`} onClick={() => makeCode(it.phone)} className="rounded-lg bg-[#6A38C7] px-3 py-1.5 text-xs font-bold text-white hover:bg-[#5a2eb0]">{it.code && left > 0 ? "Buat ulang kode" : "Buat kode tautan"}</button>
                  {it.linked && <button data-testid={`lid-link-unlink-${it.phone}`} onClick={() => unlink(it.phone)} className="inline-flex items-center gap-1 rounded-lg bg-rose-100 px-3 py-1.5 text-xs font-bold text-rose-700 hover:bg-rose-200"><LinkBreak size={14} /> Lepas</button>}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
